import http from "./axios";

const queryPage = ({ pageSize, pageNo }) => {
  return http.get("/manager/paramAppoint/cityPlatformOrderPage", {
    pageSize,
    pageNo,
  });
};

const allParamList = () => {
  return http.get("/manager/platform/allParamList");
};

const addData = ({ cityIdList, platformIdList }) => {
  return http.json_post("/manager/paramAppoint/addCityPlatformOrder", {
    cityIdList,
    platformIdList,
  });
};

const editData = ({ id, cityIdList, platformIdList }) => {
  return http.json_post("/manager/paramAppoint/editCityPlatformOrder", {
    id,
    cityIdList,
    platformIdList,
  });
};

const deleteData = ({ id }) => {
  return http.json_post("/manager/paramAppoint/deleteCityPlatformOrder", {
    id,
  });
};

export default {
  queryPage,
  deleteData,
  addData,
  editData,
  allParamList,
};
